var Marionette = require('marionette'),
    BabySitterView = require('../../../common/BabySitterView'),
     _ = require('underscore'),
    $ = require('jquery'),
    NavView = require('./nav/nav'),
    ModeView = require('./modeBtns/modeBtns'),
    ZoomView = require('./zoom/zoom'),
    RotateView = require('./rotate/rotate'),
    UnrenderablePgsDD = require('./unrenderablePgDD/unrenderablePgsPDF');

//TODO: break out unselectable from extendJQuery
require('extendJQuery');


var FULL_SCREEN_BTN_CLASS = 'fullScreen',
    FULL_SCREEN_ICON = 'icon-resize-full-1';

module.exports = BabySitterView.extend({ //item or layout
    template: require('./headerCenter.hbs'),
    onRender: function() {
        Backbone.View.prototype.unwrap.call(this);
        this.$el.unselectable();
    },
    FULL_SCREEN_BTN_CLASS: FULL_SCREEN_BTN_CLASS,
    FULL_SCREEN_ICON: FULL_SCREEN_ICON,
    ROTATE_DISABLE_CLASS: 'hide',
    fullScreenTemplateOpts: function(showFullScreen) {
        return {
            showToggleFullScreenBtn: showFullScreen,
            fullScreenBtnClass: FULL_SCREEN_BTN_CLASS,
            fullScreenIcon: FULL_SCREEN_ICON
        };
    },
    serializeData: function() {
        var vCh = this.options.vChannel,
            ad = vCh.request('activeDocument'),

            options = _.extend({
                viewModeClass: vCh.request('viewMode') + '-mode',
                containerTitle: ad.containerTitle(),
                containerType: ad.getContainerType().toLowerCase(),
                friendlyContainerType: ad.friendlyContainerType(),
                containerIcon: ad.getContainerIcon(),
                showUnrenderablePgsDropDown: this._unrenderablePgsExist(),
                disallowRotate:  vCh.request('disableRotation'),
                disallowScale: vCh.request('disableScaling'),
                ROTATE_DISABLE_CLASS: this.ROTATE_DISABLE_CLASS
            }, this.fullScreenTemplateOpts( !vCh.request('settings').fullScreen() ));

         return options;
    },
    ui: {
        modeBtnView:            '.FV-mode',
        navView:                '.FV-nav',
        documentScaleView:      '.zoom-docMode',
        pageScaleView:          '.zoom-pgMode',
        unrenderablePgsDD:      '#pdf-md-unrenderable',
        rotateEl:               '.FV-rotate',
        fullScreenToggleBtn:    '.' + FULL_SCREEN_BTN_CLASS,
        fullScreenIcon:         '.' + FULL_SCREEN_ICON,
        docSelect:              '#docSelect'
    },
    events: {
        'click @ui.fullScreenToggleBtn': 'toggleFullScreenClick'
    },
    toggleFullScreenClick: function() {
        /* note: allow click to propagate to body so dropdown menu's close */
        this.options.vChannel.command('toggleFullScreenMode'); // should forward ...
    },
    onBeforeShow: function() {

        var vCh = this.options.vChannel,
            ddContainer = {
                container: vCh.request('getWrapper')  // should get from local channel
            };
            this.children
                .add(
                    new NavView({
                        el: this.ui.navView,
                        vChannel: vCh
                    }), 'nav')
                .add(
                    new ModeView({
                         el: this.ui.modeBtnView,
                         vChannel: vCh
                    }), 'modeBtns');

        vCh.request('docHasRenderablePgs') && this.children.add( new RotateView({ //todo: include url with this?
            el: this.ui.rotateEl,
            vChannel: vCh,
            ddOptions: _.extend({
                hPos: 'right',
                ddNoSelect: true,
                activeClass: 'popupOpen'
            }, ddContainer)
        }), 'rotate');

        this._unrenderablePgsExist() && this.children.add( new UnrenderablePgsDD({  //(only if they exist )
            el: this.ui.unrenderablePgsDD,
            vChannel: vCh,
            ddOptions: _.extend({
                ddNoSelect: true
            }, ddContainer)
        }), 'unrenderablePagesDD');

        this.children.call('render');

    },
    _unrenderablePgsExist: function() {
       return this.options.vChannel.request('docHasSomeUnrenderablePDFModePgs');
    },
    /* note: must be done after scale models is set */
    onRenderZoomView: function(scale) {
        var mode = scale.get('mode');
        this.children.add( new ZoomView({
            el:  this.ui[mode + 'ScaleView'],
            model: scale,
            vChannel: this.options.vChannel
        }).render(), mode + 'ZoomDD');
    },
    updatePostScale: function(mode, scale, prevScale, scaleModel) {
        this.children.findByCustom(mode + 'ZoomDD').children.findByIndex(0).updatePostScale(scaleModel, scale); //TODO: make event
    },
    onToggleFullScreen: function(isFullScreen) {
        var $icon = this.ui.fullScreenIcon;
        $icon.removeClass('icon-resize-' + (isFullScreen ? 'full-1': 'small-1'))
             .addClass('icon-resize-' + (isFullScreen ? 'small-1': 'full-1'))
             .prop('title', isFullScreen ? 'Resize' : 'Full Screen');
    },
    toggleHeaderViewModeState: function(mode, prevMode) {

        this.$el.removeClass(prevMode + '-mode').addClass(mode + '-mode');

        !this.dropdown &&
            this.children.findByCustom('modeBtns').setActiveMode(mode); //(quick fix: don't do to overflow)

        this.toggleScaleEnabled( this.options.vChannel.request('disableScaling') );

    },
    updatePostPageChange: function(opts) {
        this.toggleRotateEnabled(opts.disableRotation);
        this.toggleScaleEnabled(opts.disableScaling);
    },
    toggleRotateEnabled: function(disable) {
        this.ui.rotateEl.removeClass(this.ROTATE_DISABLE_CLASS); //first remove the non-default
        disable && this.ui.rotateEl.addClass(this.ROTATE_DISABLE_CLASS);
    },
    toggleScaleEnabled: function(disable) {
        this.ui.documentScaleView.add(this.ui.pageScaleView).toggleClass('hide', disable);
    },
    destroy: function() {

        BabySitterView.prototype.destroy.apply(this, arguments);

        /* jq cache / detached nodes */
        this.$el = null;
        this.el = null;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/headerCenter.js
 ** module id = 713
 ** module chunks = 0
 **/